import type { ServiceLabel } from './types';

export const PAK_SERVICES: readonly ServiceLabel[] = [
  { key: 'FBR Income Tax',         label: 'FBR Income Tax Return',     jurisdiction: 'PAK' },
  { key: 'Sales Tax Return',        label: 'Sales Tax Return',          jurisdiction: 'PAK' },
  { key: 'NTN Registration',        label: 'NTN Registration',         jurisdiction: 'PAK' },
  { key: 'EOBI/PESSI',              label: 'EOBI/PESSI Payroll',        jurisdiction: 'PAK' },
  { key: 'Bookkeeping',             label: 'Bookkeeping',              jurisdiction: 'PAK' },
  { key: 'Sales Tax Registration',  label: 'Sales Tax Registration',   jurisdiction: 'PAK' },
  { key: 'Income Tax Return',       label: 'Income Tax Return Filing',  jurisdiction: 'PAK' },
  { key: 'Withholding Tax',         label: 'Withholding Tax Statements', jurisdiction: 'PAK' },
  { key: 'Annual Return',           label: 'Annual Return Filing (SECP)', jurisdiction: 'PAK' },
  { key: 'Directors Change',        label: 'Change of Directors / Shareholders', jurisdiction: 'PAK' },
  { key: 'EOBI Compliance',         label: 'EOBI Compliance',         jurisdiction: 'PAK' },
  { key: 'Social Security',         label: 'Social Security Compliance', jurisdiction: 'PAK' },
  { key: 'PRA Returns',             label: 'PRA / SRB / KPRA / BRA Returns', jurisdiction: 'PAK' },
  { key: 'Individual Tax',          label: 'Individual Tax Returns',  jurisdiction: 'PAK' },
  { key: 'Other',                   label: 'Other',                    jurisdiction: 'PAK' },
] as const;